/**
 * Extrai mensagem de erro amigável a partir da resposta de erro da API (axios).
 * Útil para exibir no modal/UI em vez de detalhes técnicos.
 */
export function extractApiErrorMessage(
  error: unknown,
  fallback: string = 'Ocorreu um erro. Tente novamente.'
): string {
  if (error == null) return fallback;

  const err = error as { response?: { data?: unknown }; message?: string };

  if (err.response?.data != null) {
    const data = err.response.data;
    if (typeof data === 'string') return data;
    if (typeof data === 'object') {
      const d = data as Record<string, unknown>;
      if (typeof d.detail === 'string') return d.detail;
      if (typeof d.errors === 'string') return d.errors;
      const first = Object.values(d)[0];
      if (Array.isArray(first) && first.length > 0 && typeof first[0] === 'string') return first[0];
      if (typeof first === 'string') return first;
    }
  }

  if (typeof err.message === 'string' && err.message) return err.message;
  return fallback;
}
